import CommonAPIService from './CommonHandler';
import { store } from '../store';
import { intervalToMilliseconds } from '../utils';

export class MeAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getUserData(router) {
    const url = `/api/me`;
    return this.CommonAPIService.getCall(url, router)
      .then(data => {
        store.dispatch('ADD_USERID', data.id);
        store.dispatch('ADD_USERNAME', data.username);
        store.dispatch('ADD_USER_GROUPS', data.auth_groups);
        store.dispatch('SET_LOGGED_IN', true);
        store.commit('SET_TIMEOUT', intervalToMilliseconds(data.timeout));
        store.commit('SET_ACTIVE_TIMER');
        return data;
      }).catch((e) => {
        console.debug('❌ /api/me failed:', (e && e.response && e.response.data && e.response.data.description) || e.message || e);
        return null; // Prevent unhandled rejection; safe since router.js has try/catch
      });
  }
}
export default MeAPIService;